import Button from '@material-ui/core/Button';
import FunctionButton from 'shared/components/FunctionButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { TextField } from 'shared/reduxFormMaterialUi/TextField';
import { validateRequiredFields } from 'shared/utils/reduxFormHelpers';
import { withStyles } from '@material-ui/core/styles';
import Customer from 'models/Customer';

const requiredFields = [
	{ name: 'email', description: 'Email' },
	{ name: 'password', description: 'Password' },
];

const styles = theme => ({
	button: {
		backgroundColor: theme.palette.primary.main,
		color: theme.palette.getContrastText(theme.palette.primary.main),
		'&:hover': {
			backgroundColor: theme.palette.primary.light,
		},
	},
	labelArea: {
		textAlign: 'center',
	},
	inputField: {
		padding: '8px 0px 15px',
	},
	emailCartContainer: {
		/* Center this */
		margin: '0 auto',
		width: 350,
		padding: '2em',
		fontSize: '12pt',
		fontFamily: theme.typography.fontFamily,

		'@media only screen and (max-height: 600px) and (orientation: landscape)': {
			height: '70vh',
			overflow: 'auto',
		},
		'@media only screen and (max-width: 600px) and (orientation: portrait)': {
			width: '70vw',
		},
	},
	emailCartHeader: {
		/* Center this */
		textAlign: 'center',
		fontSize: '14pt',
		padding: 8,
		fontWeight: 'bold',
	},
	emailCartInputArea: {
		paddingTop: 12,
		paddingBottom: 24,
	},
	loginSignUp: {
		textAlign: 'center',
		padding: 4,
	},
	submitContainer: {
		position: 'relative',
		textAlign: 'center',
		paddingBottom: 8,
	},
	messageHeader: {
		fontSize: '14pt',
		paddingBottom: '10px',
	},
	messageContinueBrowsing: {
		textAlign: 'right',
		paddingTop: '10px',
	},
});

/**
 * Display a login form.
 * @param {React props} props
 */
const EmailCartForm = props => {
	const {
		cancelToken,
		classes,
		handleSubmit,
		emailCart,
		customer,
		LoginSingup,
		emailCartMessage,
		closeEmailCart,
	} = props;

	return (
		<div className={classes.emailCartContainer}>
			{emailCartMessage !== undefined ? (
				<div>
					<div className={classes.messageHeader}>Thank you! </div>
					{emailCartMessage}
					<div className={classes.messageContinueBrowsing}>
						<Button type="submit" className={classes.button} onClick={closeEmailCart} size="medium">
							Continue Browsing
						</Button>
					</div>
				</div>
			) : (
				<div>
					{!customer.isGuest ? (
						<div>
							<div className={classes.emailCartHeader}>Send to My Email</div>
							<div className={classes.labelArea}>Your email is saved as</div>
							<div className={classes.labelArea}>{customer.emailAddress}</div>
							<Button
								type="submit"
								className={classes.button}
								onClick={() => {
									emailCart(cancelToken, true, '', '', '');
								}}
							>
								CONFIRM EMAIL AND SEND
							</Button>
						</div>
					) : (
						<div className={classes.loginSignUp}>
							Don&apos;t have an account?
							<FunctionButton label="Login/Sign up" onClickFunction={LoginSingup} />
						</div>
					)}
					<br />
					<div className={classes.emailCartHeader}>Or Send to an Email Address</div>
					<form onSubmit={handleSubmit(values => emailCart(cancelToken, false, values.email, values.customerEmail, values.customerName))}>
						<div className={classes.emailCartInputArea}>
							{customer.isGuest ? (
								<div>
									<Field
										name="customerEmail"
										className={classes.inputField}
										label={<div style={{ marginTop: 10 }}>Your Email</div>}
										component={TextField}
									/>
									<Field
										name="customerName"
										className={classes.inputField}
										label={<div style={{ marginTop: 10 }}>Your Name</div>}
										component={TextField}
									/>
								</div>
							): ("")}
							<Field
								name="email"
								className={classes.inputField}
								label={<div style={{ marginTop: 10 }}>Recipient Email</div>}
								component={TextField}
							/>
						</div>
						<div className={classes.submitContainer}>
							<Button type="submit" className={classes.button} >
								SEND EMAIL
							</Button>
						</div>
					</form>
				</div>
			)}
		</div>
	);
};

EmailCartForm.propTypes = {
	cancelToken: PropTypes.objectOf(PropTypes.any).isRequired,
	classes: PropTypes.shape({
		button: PropTypes.string,
		inputField: PropTypes.string,
		labelArea: PropTypes.string,
		emailCartContainer: PropTypes.string,
		emailCartHeader: PropTypes.string,
		emailCartInputArea: PropTypes.string,
		loginSignUp: PropTypes.string,
		submitContainer: PropTypes.string,
		messageHeader: PropTypes.string,
		messageContinueBrowsing: PropTypes.string,
	}).isRequired,
	handleSubmit: PropTypes.func.isRequired,
	customer: PropTypes.instanceOf(Customer).isRequired,
	emailCart: PropTypes.func.isRequired,
	LoginSingup: PropTypes.func.isRequired,
	emailCartMessage: PropTypes.string.isRequired,
	closeEmailCart: PropTypes.func.isRequired,
};

// Testing
export { EmailCartForm as EmailCartFormClass };

export default reduxForm({
	form: 'EmailCartForm',
	validate: validateRequiredFields(requiredFields),
})(withStyles(styles, { name: 'EmailCartForm' })(EmailCartForm));
